import React from "react";

export default function HeroLicenciatura({
  bgImage = "/images/Top.png",
  accent = "#f4c296ff",
  baseBlue = "#0f3b63",
  cutColor = "#ffffff",
  title = "LICENCIATURA EN",
  highlight = "MARKETING DIGITAL.",
  subtitle = "VALIDEZ OFICIAL ANTE LA SEP CCT",
  cct = "07ESU0016A",
}) {
  const sectionStyle = {
    position: "relative",
    zIndex: 1,
    minHeight: 420,
    color: "#fff",
    overflow: "hidden",
    background: baseBlue,
  };

  const bgStyle = {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    backgroundImage: `linear-gradient(0deg, rgba(15,59,99,.9), rgba(15,59,99,.9)), url('${bgImage}')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const contentStyle = {
    position: "relative",
    zIndex: 2,
    maxWidth: 1200,
    margin: "0 auto",
    padding: "3rem 1rem 2rem",
  };

  const h1Style = {
    margin: 0,
    lineHeight: 1.1,
    fontWeight: 900,
    fontSize: "clamp(28px, 4.5vw, 56px)",
  };

  const highlightStyle = {
    display: "block",
    color: accent,
  };

  const smallStyle = {
    marginTop: 14,
    color: "rgba(255,255,255,.92)",
    fontWeight: 600,
    letterSpacing: ".3px",
  };

  const waveStyle = {
    position: "absolute",
    zIndex: 30,
    left: 0,
    right: 0,
    bottom: -1,
    width: "100%",
    height: 220,
    display: "block",
    pointerEvents: "none",
  };

  const curveD =
    "M0,160 C240,240 480,60 720,150 C960,240 1200,100 1440,180";

  const cutD = `${curveD} L1440,220 L0,220 Z`;

  const showFooterText = subtitle || cct;

  return (
    <section style={sectionStyle}>
      <div style={bgStyle} />

      <div style={contentStyle}>
        <div className="grid">
          <div className="col-12 md:col-8">
            <h1 style={h1Style}>
              {title}
              {highlight && <span style={highlightStyle}>{highlight}</span>}
            </h1>

            {showFooterText && (
              <p style={smallStyle}>
                {subtitle && <>{subtitle} </>}
                {cct && <b style={{ color: accent }}>{cct}</b>}
              </p>
            )}
          </div>
        </div>
      </div>

      <svg
        style={waveStyle}
        viewBox="0 0 1440 220"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path d={cutD} fill={cutColor} />
        <path
          d={curveD}
          fill="none"
          stroke={accent}
          strokeWidth="18"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </section>
  );
}